<template>
  <div class="other-filter-area" :class="isSticky ? 'shadow' : ''">
    <div class="left-content">
      <!-- 排序方式 -->
      <div class="sort-type-block">
        <div class="sort-type default" :class="{ active: sort === '' }" @click="sortChange('')">默认</div>
        <i class="divider"></i>
        <div class="sort-type simple-click-hover" :class="{ active: sort === 1 }" @click="sortChange(1)">访问量</div>
        <i class="divider"></i>
        <div class="sort-type simple-click-hover" :class="{ active: sort === 2 }" @click="sortChange(2)">收藏量</div>
        <i class="divider"></i>
        <div class="sort-type simple-click-hover" :class="{ active: sort === 3 }" @click="sortChange(3)">下载量</div>
        <i class="divider"></i>
        <div class="sort-type simple-click-hover" :class="{ active: sort === 4 }" @click="sortChange(4)">最新发布</div>
      </div>
      <i class="divider"></i>
      <!-- 其他筛选条件 -->
      <div class="other-filter">
        <el-checkbox v-model="showAdv" @change="showAdvChange">显示广告</el-checkbox>
      </div>
    </div>
    <div class="right-content">
      <!-- 搜索的产品数 -->
      <div class="prod-count">
        共计<span>{{ count }}</span>个企业
      </div>
    </div>
  </div>
</template>
<script>
import {WatchSticky} from 'sticky-change';

const storgeShowAdv = window.sessionStorage.getItem('show_adv');
const showAdvBool = storgeShowAdv == null ? true : !!(Number(storgeShowAdv));

export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      sort: '', // 排序 1 访问量, 2 收藏量, 3 下载量, 4 最新发布]
      isSticky: false,
      showAdv: true,
    };
  },
  mounted() {
    new WatchSticky(
      document.querySelector('.other-filter-area'), 
      null,
      () => {
        this.isSticky = true;
      },
      () => {
        this.isSticky = false;
      }
    )
  },
  methods: {
    // 修改产品的排序
    sortChange(_sort) {
      this.sort = _sort;
      this.$emit("search");
    },
    showAdvChange() {
      // window.sessionStorage.setItem('show_adv', Number(this.showAdv));
      this.$emit('search')
    }
  },
};
</script>
<style lang="less" scoped>
.other-filter-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  font-size: 12px;
  color: #111a2a;
  position: sticky;
  top: -16px;
  z-index: 6;
  background: @content-bg;
  padding: 0 28px 0 16px;
  &.shadow{
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  }
  & > div {
    align-self: center;
  }
  .other-filter{
    height: 26px;
    display: flex;
    align-items: center;
  }
}

.left-content,
.right-content {
  display: flex;
  align-items: center;
}

// 搜到的产品个数
.prod-count {
  font-size: 14px;
  color: #4a4a4a;

  span {
    color: @a-color-active;
  }
}

.select-address {
  cursor: pointer;
  position: relative;

  i {
    margin-left: 9px;
  }

  .address-select {
    position: absolute;
    top: 30px;
    width: 460px;
    padding: 12px 12px 15px;
    border: 1px solid #cecbce;
    background: #ffffff;
    box-shadow: 0 0 5px #ddd;
    z-index: 100;
  }
}

// 排序方式
.sort-type-block {
  display: flex;
  align-items: center;
  font-size: 14px;

  .sort-type {
    padding: 5px 10px;

    &.default {
      cursor: pointer;
    }

    &.default.active {
      cursor: default;
    }

    &.active {
      color: @a-color-active;
    }
  }
}

.divider {
  width: 1px;
  height: 14px;
  background: #E7E9ED;
  margin: 0 10px;
}

// 地图模式按钮
.map-button {
  display: flex;
  align-items: center;
  margin-left: 40px;

  img {
    margin-right: 5px;
  }
}
</style>